import React from 'react';
import {Link} from "react-router-dom";

function AgreementComponent(props) {
    const termsAndConditions = <Link className="form__group__check__text__action" to="/help-center/legal/terms" target="_blank">Terms & Conditions</Link>
    const privacyPolicy = <Link className="form__group__check__text__action" to="/help-center/legal/data-protection" target="_blank">Privacy Policy</Link>
    const cookiesPolicy = <Link className="form__group__check__text__action" to="/help-center/legal/cookie" target="_blank">Cookies Policy</Link>
    return (
        <React.Fragment>
            <div className={props.formClass}>
                <label className="form__group__check" htmlFor="terms">
                    <input className="form__group__check__input"
                           type="checkbox"
                           id="terms"
                           value={props.userAgreementAccepted}
                           onChange={props.handleToggleUserAgreementAccepted}
                           checked={props.userAgreementAccepted}
                           disabled={props.disabled}
                    />
                    <span className="form__group__check__check"></span>
                    <span className="form__group__check__text">
                        I agree with bubblyPolls {termsAndConditions}, {privacyPolicy} & {cookiesPolicy}
                    </span>
                </label>
            </div>
        </React.Fragment>
    )
}

export default AgreementComponent;